/**
 * @file Profile picture component
 * @author Heino Lenting
 */
/**
 * Class for the Porifle picture for handling profile picatures with nice graphical fallback
 */
var ProfilePictureComponent = /** @class */ (function () {
    /**
     * Constructs an ProfilePicture Component
     */
    function ProfilePictureComponent() {
        /**
         * Holds the colors used for displaying the profile picture
         */
        this.colors = [
            '#fb9fa7',
            '#0079a9',
            '#974463',
            '#57405d',
            '#54c1d9',
            '#999653',
            '#ffd46e',
            '#fa853b',
            '#f7674e',
            '#d31433',
            '#dbc996',
            '#674642',
            '#ef4e76',
            '#2e445b',
            '#306476',
            '#57815d',
            '#727158',
            '#e8a055',
            '#b44837',
            '#843e43'
        ];
        /**
         * The color used for this profile picture
         */
        this.color = '#ffffff';
        /**
         * The initials used for this profile picture
         */
        this.initials = '';
    }
    Object.defineProperty(ProfilePictureComponent.prototype, "fullName", {
        /**
         * Used for receiving the full name from the parent component
         */
        set: function (value) {
            this.color = this.pickColor(value);
            this.initials = this.collectInitials(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Method to translate a name into initials
     * @param name The (full) name of the profile user
     */
    ProfilePictureComponent.prototype.collectInitials = function (name) {
        var initials = '';
        var nameParts = name.split(' ');
        nameParts.forEach(function (namePart, index) {
            if (index < 3) { // Keep the initials short
                initials += namePart.charAt(0);
            }
        });
        return initials;
    };
    /**
     * Method to pick a color based on the (full) name
     * @param name The (full) name of the profile user
     */
    ProfilePictureComponent.prototype.pickColor = function (name) {
        if (!name) {
            console.warn('Pick color is not working if no name exists');
            return this.colors[0];
        }
        // Count the char codes
        var charCodeCount = 0;
        for (var i = 0; i < name.length; i++) {
            charCodeCount += name.charCodeAt(i);
        }
        // And use this together with the remainder function to
        // map the numbers to the available colors.
        var remainder = charCodeCount % this.colors.length;
        // Pick the color and return it
        return this.colors[remainder];
    };
    /**
     * Translate the size in something with 'px'
     */
    ProfilePictureComponent.prototype.sizeInPx = function () {
        return this.size + 'px';
    };
    /**
     * Translate the size in font size with 'px'
     */
    ProfilePictureComponent.prototype.fontSizeInPx = function () {
        return (this.size * 0.35) + 'px';
    };
    return ProfilePictureComponent;
}());
export { ProfilePictureComponent };
